(() => {
 document.addEventListener('click',event=>{
  const link=event.target.closest('main[data-template^="product"] a[href*="/pages/contact?product="]');
  if(!link)return;
  const scope=link.closest('product-info')||document.querySelector('product-info')||document.querySelector('main');
  const picker=scope.querySelector('variant-selects');
  if(!picker)return;
  const values=[...picker.querySelectorAll('select option:checked,fieldset input:checked')].map(option=>option.value).filter(Boolean);
  if(!values.length)return;
  const url=new URL(link.href,location.origin);url.searchParams.set('variant',values.join(' / '));link.href=url.toString();
 });
 function initGuideControls(){
  document.querySelectorAll('.frx-discover').forEach(section=>{
   const track=section.querySelector('.frx-drow'),controls=section.querySelector('.frx-guide-controls');
   if(!track||!controls||controls.dataset.ready)return;
   controls.dataset.ready='true';
   const previous=controls.querySelector('[data-guide-prev]'),next=controls.querySelector('[data-guide-next]');
   const update=()=>{const max=track.scrollWidth-track.clientWidth;controls.hidden=max<2;previous.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft>=max-2;};
   const move=direction=>track.scrollBy({left:direction*(track.clientWidth+20),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
   previous.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));
   track.addEventListener('scroll',update,{passive:true});new ResizeObserver(update).observe(track);update();
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initGuideControls);else initGuideControls();
 document.addEventListener('shopify:section:load',initGuideControls);
})();
